export default class skipToContent {
    constructor () {
        $('.skip-to-content').click(e => {
            this._skipTo();
            e.preventDefault();
        });

        $('.skip-to-content').keyup(e => {
            if (e.which === 13) {
                this._skipTo();
                e.preventDefault();
            }
        });
    }

    _skipTo () {
        $('main').attr('tabindex', 0).focus();

        $('html,body').animate({
            scrollTop: ($('main').offset().top),
        });
    }
}